// Ongelmat on a map (#1326): kipupisteet.v2 — the `kipupisteetV2` namespace.
// v1's dialogue screen keeps its own strings under `kipupisteV2`.

export const kipupisteetV2Fi = {
  accept: 'Hyväksy',
  describeLabel: 'KUVAILE ONGELMA',
  placeholder: 'Kirjoita ongelma tähän…',
  continue: 'Jatka',
  question: 'Minkä ongelman olet tunnistanut tässä aiheessa?',
  add: 'Lisää ongelma',
  mine: 'Omat',
  all: 'Kaikki',
  kooste: 'Kooste',
  k: {
    pending: 'Kooste valmistuu',
    pendingHint: 'Fasilitaattori avaa sen hetken päästä.',
    generating: 'Koostetaan ongelmia…',
    generatingHint: 'Ongelmat ryhmitellään ja lähteet luetaan. Tämä kestää noin minuutin.',
    failed: 'Tekoäly ei saanut koostetta muodostettua, joten näkyvissä ovat vain luvut.',
    failedWhy: 'Syy: {{why}}',
    problems: '{{count}} ongelmaa',
    problemOne: '1 ongelma',
    pairs: '{{count}} paria',
    pairOne: '1 pari',
    areas: '{{count}} aluetta',
    areaOne: '1 alue',
    singles: '{{count}} yksittäistä',
    singleOne: '1 yksittäinen',
    badgeResearch: 'Tutkimus tukee',
    badgeTacit: 'Hiljaista tietoa',
    singletons: 'Yksittäiset',
    sourcesRaise: 'Lähteet nostavat, osallistujat eivät',
    addMissing: 'Lisää puuttuva ongelma',
    sourceContext: 'Lähde nostaa',
    web: 'Verkkolähde',
    aiDraft: 'Tekoälyn luonnos, tarkista ennen lukitsemista',
    aiChecked: 'Tekoälyn luonnos, fasilitaattori tarkistanut',
    lock: 'Lukitse ja näytä',
    locked: 'Lukittu: osallistujat näkevät koosteen',
    edit: 'Muokkaa',
    save: 'Tallenna',
    cancel: 'Peru',
    members: 'Kaikki ongelmat ({{count}})',
    hideMembers: 'Piilota ongelmat',
    moveTo: 'Siirrä',
    toSingletons: 'Yksittäisiin',
    removeTopic: 'Poista aihe',
    saveFailed: 'Muutosta ei tallennettu: {{why}}',
    themes: 'Yhteiset teemat',
    konsensus: 'Konsensus',
    konsensusNone: 'Kukaan ei kirjoittanut samaa ongelmaa kuin toinen pari.',
    blindSpots: 'Sokeat pisteet',
    blindSpotsNone: 'Lähteistä ei noussut aihetta, jota ongelmat eivät jo kattaisi.',
    combine: 'Yhdistä',
    combineConfirm: 'Yhdistetäänkö {{count}} ongelmaa yhdeksi? Jäljelle jää muotoilu: ”{{text}}”. Se on jatkossa jokaisen kirjoittajan oma ongelma.',
    again: 'Päivitä kooste',
    againConfirm: 'Tehdäänkö kooste uudelleen nykyisistä ongelmista? Edellinen tallentuu, mutta sen muokkaukset eivät siirry, ja kooste on osallistujilta piilossa, kunnes lukitset sen uudelleen.',
  },
  hideTitles: 'Piilota otsikot',
  showTitles: 'Näytä otsikot',
  allCount: 'Kaikki, {{count}} ongelmaa',
  titleLabel: 'Ongelma',
  saveEdit: 'Tallenna',
  saving: 'Tallennetaan…',
  close: 'Sulje',
  editTitle: 'Muokkaa ongelmaa',
  discardMessage: 'Hylätäänkö kirjoittamasi ongelma?',
  discardConfirm: 'Hylkää',
  error: 'Jokin meni pieleen',
  reading: 'Luetaan ongelmaa…',
  other: 'Muu…',
  otherPlaceholder: 'Kirjoita oma vastauksesi…',
  skip: 'Ohita',
  undoSkip: 'Kysy sittenkin',
  saveAsIs: 'Tallenna sellaisenaan',
  composing: 'Yhdistetään…',
  composedTitle: 'Näin ongelmasi kuuluu nyt:',
  returnOriginal: 'Palaa alkuperäiseen',
  delete: 'Poista ongelma',
  deleteMessage: 'Poistetaanko ongelma? Sitä ei voi palauttaa.',
  deleteConfirm: 'Poista',
  deleteBlocked: 'Ongelmaa ei voi poistaa, koska sen pohjalle on jo rakennettu muutoksen esteitä.',
  spar: 'Sparraile',
  sparringFailed: 'Tekoäly ei nyt vastannut. Yritä uudelleen tai tallenna sellaisenaan.',
};

export const kipupisteetV2En = {
  accept: 'Accept',
  describeLabel: 'DESCRIBE THE PROBLEM',
  placeholder: 'Write the problem here…',
  continue: 'Continue',
  question: 'Which problem have you identified in this topic?',
  add: 'Add a problem',
  mine: 'Mine',
  all: 'All',
  kooste: 'Summary',
  k: {
    pending: 'The summary is on its way',
    pendingHint: 'The facilitator will open it shortly.',
    generating: 'Summarising the problems…',
    generatingHint: 'Grouping the problems and reading the sources. This takes about a minute.',
    failed: 'The AI could not make the summary, so only the figures are shown.',
    failedWhy: 'Why: {{why}}',
    problems: '{{count}} problems',
    problemOne: '1 problem',
    pairs: '{{count}} pairs',
    pairOne: '1 pair',
    areas: '{{count}} areas',
    areaOne: '1 area',
    singles: '{{count}} on their own',
    singleOne: '1 on its own',
    badgeResearch: 'Research supports',
    badgeTacit: 'Tacit knowledge',
    singletons: 'On their own',
    sourcesRaise: 'The sources raise, the participants do not',
    addMissing: 'Add the missing problem',
    sourceContext: 'A source raises',
    web: 'Web source',
    aiDraft: 'AI draft, check before locking',
    aiChecked: 'AI draft, checked by the facilitator',
    lock: 'Lock and show',
    locked: 'Locked: participants see the summary',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    members: 'All problems ({{count}})',
    hideMembers: 'Hide the problems',
    moveTo: 'Move',
    toSingletons: 'On their own',
    removeTopic: 'Remove topic',
    saveFailed: 'The change was not saved: {{why}}',
    themes: 'Shared themes',
    konsensus: 'Consensus',
    konsensusNone: 'No pair wrote the same problem as another.',
    blindSpots: 'Blind spots',
    blindSpotsNone: 'The sources raised no topic the problems do not already cover.',
    combine: 'Combine',
    combineConfirm: 'Combine {{count}} problems into one? The wording kept is: “{{text}}”. From now on it is every writer\u2019s own problem.',
    again: 'Update the summary',
    againConfirm: 'Make the summary again from the current problems? The previous one is kept, but its edits do not carry over, and the participants do not see the summary until you lock it again.',
  },
  hideTitles: 'Hide titles',
  showTitles: 'Show titles',
  allCount: 'All, {{count}} problems',
  titleLabel: 'Problem',
  saveEdit: 'Save',
  saving: 'Saving…',
  close: 'Close',
  editTitle: 'Edit the problem',
  discardMessage: 'Discard the problem you wrote?',
  discardConfirm: 'Discard',
  error: 'Something went wrong',
  reading: 'Reading the problem…',
  other: 'Other…',
  otherPlaceholder: 'Write your own answer…',
  skip: 'Skip',
  undoSkip: 'Ask after all',
  saveAsIs: 'Save as it is',
  composing: 'Combining…',
  composedTitle: 'This is how your problem reads now:',
  returnOriginal: 'Back to the original',
  delete: 'Delete problem',
  deleteMessage: 'Delete the problem? It cannot be restored.',
  deleteConfirm: 'Delete',
  deleteBlocked: 'The problem cannot be deleted: obstacles to change have already been built on it.',
  spar: 'Spar',
  sparringFailed: 'The AI did not answer this time. Try again, or save it as it is.',
};

export const kipupisteetV2Sv = {
  accept: 'Godkänn',
  describeLabel: 'BESKRIV PROBLEMET',
  placeholder: 'Skriv problemet här…',
  continue: 'Fortsätt',
  question: 'Vilket problem har du identifierat i det här ämnet?',
  add: 'Lägg till ett problem',
  mine: 'Mina',
  all: 'Alla',
  kooste: 'Sammandrag',
  k: {
    pending: 'Sammandraget är på väg',
    pendingHint: 'Facilitatorn öppnar det strax.',
    generating: 'Problemen sammanfattas…',
    generatingHint: 'Problemen grupperas och källorna läses. Det tar ungefär en minut.',
    failed: 'AI:n kunde inte göra sammandraget, så bara siffrorna visas.',
    failedWhy: 'Orsak: {{why}}',
    problems: '{{count}} problem',
    problemOne: '1 problem',
    pairs: '{{count}} par',
    pairOne: '1 par',
    areas: '{{count}} områden',
    areaOne: '1 område',
    singles: '{{count}} enskilda',
    singleOne: '1 enskilt',
    badgeResearch: 'Forskning stöder',
    badgeTacit: 'Tyst kunskap',
    singletons: 'Enskilda',
    sourcesRaise: 'Källorna lyfter, deltagarna inte',
    addMissing: 'Lägg till det saknade problemet',
    sourceContext: 'En källa lyfter',
    web: 'Webbkälla',
    aiDraft: 'AI-utkast, granska innan du låser',
    aiChecked: 'AI-utkast, granskat av facilitatorn',
    lock: 'Lås och visa',
    locked: 'Låst: deltagarna ser sammandraget',
    edit: 'Redigera',
    save: 'Spara',
    cancel: 'Avbryt',
    members: 'Alla problem ({{count}})',
    hideMembers: 'Dölj problemen',
    moveTo: 'Flytta',
    toSingletons: 'Till enskilda',
    removeTopic: 'Ta bort ämnet',
    saveFailed: 'Ändringen sparades inte: {{why}}',
    themes: 'Gemensamma teman',
    konsensus: 'Konsensus',
    konsensusNone: 'Inget par skrev samma problem som ett annat.',
    blindSpots: 'Blinda fläckar',
    blindSpotsNone: 'Källorna lyfte inget ämne som problemen inte redan täcker.',
    combine: 'Slå ihop',
    combineConfirm: 'Slå ihop {{count}} problem till ett? Formuleringen som blir kvar: ”{{text}}”. Från och med nu är det varje skribents eget problem.',
    again: 'Uppdatera sammanfattningen',
    againConfirm: 'Göra sammanfattningen på nytt av de nuvarande problemen? Den förra sparas, men dess ändringar följer inte med, och deltagarna ser inte sammanfattningen förrän du låser den igen.',
  },
  hideTitles: 'Dölj rubriker',
  showTitles: 'Visa rubriker',
  allCount: 'Alla, {{count}} problem',
  titleLabel: 'Problem',
  saveEdit: 'Spara',
  saving: 'Sparar…',
  close: 'Stäng',
  editTitle: 'Redigera problemet',
  discardMessage: 'Kasta problemet du skrev?',
  discardConfirm: 'Kasta',
  error: 'Något gick fel',
  reading: 'Läser problemet…',
  other: 'Annat…',
  otherPlaceholder: 'Skriv ditt eget svar…',
  skip: 'Hoppa över',
  undoSkip: 'Fråga ändå',
  saveAsIs: 'Spara som det är',
  composing: 'Slår ihop…',
  composedTitle: 'Så här lyder ditt problem nu:',
  returnOriginal: 'Tillbaka till originalet',
  delete: 'Ta bort problemet',
  deleteMessage: 'Ta bort problemet? Det kan inte återställas.',
  deleteConfirm: 'Ta bort',
  deleteBlocked: 'Problemet kan inte tas bort, eftersom hinder för förändring redan har byggts på det.',
  spar: 'Sparra',
  sparringFailed: 'AI:n svarade inte nu. Försök igen eller spara som det är.',
};
